export const MODAL_TYPE = {
  CREATE: 'create',
  EDIT: 'edit',
}
